import * as React from 'react';

function MenuIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="24" height="24" viewBox="-10 0 24 14" fill="none" {...props}>
      <circle cx="2" cy="2" r="2" fill="#727A83" />
      <circle cx="2" cy="7.5" r="2" fill="#727A83" />
      <circle cx="2" cy="13" r="2" fill="#727A83" />
    </svg>
  );
}

export default React.memo(MenuIcon);
